import * as React from "react";
import Content from "../../../Content";
import {Link} from "react-router-dom";
import Axios from "../../Components/Axios";

class Edit extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            id: this.props.match.params.id,
            title: '',
            kp_msisdn: '',
            errors: {
                kp_msisdn: false
            }
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {
        Axios
            .get(`api/kp/get/${this.state.id}`)
            .then(r => this.setState({
                kp_msisdn: r?.data?.kpMsisdn ?? '',
                title: r?.data?.title ?? ''
            }))
            .catch(() => this.props.history.push('/'));
    }

    isNumberCorrect(value) {

        if(!/^996[0-9]{9}/.test(value)) {
            this.setState(prev => ({
                errors: {
                    ...prev.errors,
                    kp_msisdn: true
                }
            }));
            this.setState({});
            return;
        }

        Axios
            .get('/api/check_msisdn/' + value + '/' + this.state.id)
            .then(r => {
                this.setState(prev => ({
                    errors: {
                        ...prev.errors,
                        kp_msisdn: !r?.success
                    }
                }));
                this.setState({});
            });
    }

    handleSubmit(e) {
        e.preventDefault();
        Axios
            .post(`api/kp/edit/${this.state.id}`, {
                kp_msisdn: this.state.kp_msisdn
            })
            .then(r => (r?.success && this.props.history.push('/admin/kp')));
    }

    handleChange(e, field) {
        this.setState({
            [field]: e.target.value
        });
    }

    render() {
        return (
            <Content title = "Редактирование КП">
                <div className="row mb-3">
                    <div className="col d-flex justify-content-between align-items-center">
                        <h5>Редактирование контент-провайдера</h5>
                    </div>
                </div>
                <div className="row my-3">
                    <div className="col-12">
                        <Link className="btn btn-light mr-4" to={'/admin/kp'}>← Назад</Link>
                    </div>
                </div>
                <form onSubmit={this.handleSubmit}>
                    <div className="form-group">
                        <label htmlFor="exampleInputEmail1 mb-2 col-12">Контент провайдер: <b>{ this.state.title }</b></label>
                    </div>
                    <div className="form-group">
                        <label htmlFor="exampleInputEmail1">Номер КП</label>
                        <input
                            className={"form-control " + (this.state.errors.kp_msisdn ? 'is-invalid' : '')}
                            placeholder="996555112233"
                            value={this?.state?.kp_msisdn}
                            onChange={e =>{ this.isNumberCorrect(e.target.value); return this.handleChange(e, 'kp_msisdn') } }
                            title={ this.state.errors.title ? 'Поле телефона имеет недопустимый формат или недопустимый номер' : '' }
                            maxLength={12}
                        />
                    </div>
                    <div className="form-group">
                        <button
                            className="btn btn-success"
                            type="submit"
                            disabled={ this.state.errors.kp_msisdn }
                        >
                            Сохранить
                        </button>
                        <Link
                            to={'/admin/kp'}
                            className="btn btn-danger ml-2"
                        >
                            Отмена
                        </Link>
                    </div>
                </form>
            </Content>
        );
    }
}

export default Edit;